import React, { useState } from "react";
import "./CabMobileSearch.css";
import { IoSwapVertical, IoTimeOutline } from "react-icons/io5";
import { FaCircle, FaMapMarkerAlt } from "react-icons/fa";
import { RxCross2 } from "react-icons/rx";
import { IoMdArrowDropdown } from "react-icons/io";
import { LocalizationProvider, MobileDateTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import CabCitySelection from "./CabCitySelection";

const CabMobileSearch = () => {
  const [activeTab, setActiveTab] = useState("AIRPORT");
  const [airportType, setAirportType] = useState("PICKUP");
  const [showReturn, setShowReturn] = useState(false);

  const [pickupData, setPickupData] = useState({ pickup: "" });
  const [dropData, setDropData] = useState({ drop: "" });
  const [transferType, setTransferType] = useState("Airport PickUp");

  // City selection UI
  const [fromCitySelected, setFromCitySelected] = useState(false);
  const [toCitySelected, setToCitySelected] = useState(false);
  // const [departureCity, setDepartureCity] = useState({});
  // const [arrivalCity, setArrivalCity] = useState({});

  const [departureCities, setDepartureCities] = useState({
  AIRPORT: {},
  OUTSTATION: {},
  HOURLY: {}
});

const [arrivalCities, setArrivalCities] = useState({
  AIRPORT: {},
  OUTSTATION: {},
  HOURLY: {}
});


  // Dates
  const [dates, setDates] = useState({
    AIRPORT: { start: null, end: null },
    OUTSTATION: { start: null, end: null },
    HOURLY: { start: null, end: null },
  });

  const [rentHours, setRentHours] = useState("1 Hour");
  const [showHoursModal, setShowHoursModal] = useState(false);

  const hours = Array.from({ length: 12 }, (_, i) => `${i + 1} Hour`);
  const navigate = useNavigate();

  const updateDate = (tripType, field, value) => {
    setDates((prev) => ({
      ...prev,
      [tripType]: { ...prev[tripType], [field]: dayjs(value) },
    }));
  };

  const handleFromCityClick = () => setFromCitySelected(true);
  const handleToCityClick = () => setToCitySelected(true);

  const closeCitySelection = () => {
    setFromCitySelected(false);
    setToCitySelected(false);
  };

  const open = () => setShowHoursModal(true);
  const close = () => setShowHoursModal(false);

  const onSelect = (hour) => {
    setRentHours(hour);
    close();
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const { start, end } = dates[activeTab];

    if (!start) {
      toast.error("Please select a date & time");
      return;
    }

    let formDataToPass = {};

    if (activeTab === "AIRPORT") {
      formDataToPass = {
        tripType: "transfer",
        transferType,
        pickup: departureCities[activeTab]?.name,
        drop: arrivalCities[activeTab]?.name,
        startDate: start.format("YYYY-MM-DD"),
        startTime: start.format("hh:mm A"),
      };
    } else if (activeTab === "OUTSTATION") {
      formDataToPass = {
        tripType: "outstation",
        pickup: departureCities[activeTab]?.name,
        drop: arrivalCities[activeTab]?.name,
        startDate: start.format("YYYY-MM-DD"),
        startTime: start.format("hh:mm A"),
        ...(end && {
          endDate: end.format("YYYY-MM-DD"),
          endTime: end.format("hh:mm A"),
        }),
      };
    } else if (activeTab === "HOURLY") {
      formDataToPass = {
        tripType: "local",
        pickup: departureCities[activeTab]?.name,
        startDate: start.format("YYYY-MM-DD"),
        startTime: start.format("hh:mm A"),
        durationHours: rentHours,
      };
    }

    const queryString = new URLSearchParams(formDataToPass).toString();
    navigate(`/cablisting?${queryString}`);
  };

  console.log("Departure City:", departureCities[activeTab]);
console.log("Arrival City:", arrivalCities[activeTab]);
console.log("Query String:", new URLSearchParams({
  pickup: departureCities[activeTab]?.name,
  drop: arrivalCities[activeTab]?.name,
}).toString());


  return (
    <div className="cabMobileSearch">
      <form onSubmit={handleSubmit}>
        {/* Top Tabs */}
        <div className="cabMobileSearch-tabs">
          {["AIRPORT", "OUTSTATION", "HOURLY"].map((tab) => (
            <div
              key={tab}
              className={`cabMobileSearch-tab ${activeTab === tab ? "active" : ""}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </div>
          ))}
        </div>

        {/* AIRPORT TAB */}
        {activeTab === "AIRPORT" && (
          <>
            {/* Pickup / Drop Switch */}
            <div className="cabMobileSearch-airportType">
              <div
                className={`cabMobileSearch-airportBtn ${
                  airportType === "PICKUP" ? "active" : ""
                }`}
                onClick={() => {
                  setAirportType("PICKUP");
                  setTransferType("Airport PickUp");
                }}
              >
                Airport Pickup
              </div>
              <div
                className={`cabMobileSearch-airportBtn ${
                  airportType === "DROP" ? "active" : ""
                }`}
                onClick={() => {
                  setAirportType("DROP");
                  setTransferType("Airport Drop");
                }}
              >
                Airport Drop
              </div>
            </div>

            {/* Pickup/Drop Inputs */}
            <div className="cabMobileSearch-card">
              {/* Pickup */}
              <div className="cabMobileSearch-locationRow">
                <div className="cabMobileSearch-icon">
                  <FaCircle size={10} />
                </div>

                <div className="cabMobileSearch-text">
                  <label className="cabMobileSearch-label">Pickup Location</label>
                  <div className="cabMobileSearch-input" onClick={handleFromCityClick}>
                    {departureCities[activeTab]?.name || "Enter Pickup Location"}
                  </div>
                </div>
              </div>

              {/* Swap */}
              <div className="cabMobileSearch-divider">
                <div className="cabMobileSearch-swapIcon">
                  <IoSwapVertical size={20} />
                </div>
              </div>

              {/* Drop */}
              <div className="cabMobileSearch-locationRow">
                <div className="cabMobileSearch-icon">
                  <FaMapMarkerAlt size={14} />
                </div>

                <div className="cabMobileSearch-text">
                  <label className="cabMobileSearch-label">Drop Location</label>
                  <div className="cabMobileSearch-input" onClick={handleToCityClick}>
                    {arrivalCities[activeTab]?.name || "Enter Drop Location"}
                  </div>
                </div>
              </div>
            </div>

            {/* Date Picker */}
            <div className="cabMobileSearch-card">
              <div className="cabMobileSearch-locationRow">
                <div className="cabMobileSearch-icon">
                  <IoTimeOutline size={18} />
                </div>

                <div>
                  <label>Pick-up Date & Time</label>
                  <div className="mobile-date-time-wrapper">
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MobileDateTimePicker
                        value={dates.AIRPORT.start}
                        onChange={(newValue) => updateDate("AIRPORT", "start", newValue)}
                        minDateTime={dayjs()}
                        ampm
                        views={["year", "month", "day", "hours", "minutes"]}
                        format="DD MMMM YYYY, hh:mm A"
                      />
                    </LocalizationProvider>
                  </div>
                </div>
              </div>
            </div>

            <button className="cabMobileSearch-searchBtn">SEARCH</button>
          </>
        )}

        {/* OUTSTATION TAB */}
        {activeTab === "OUTSTATION" && (
          <>
            {/* Pickup / Drop */}
            <div className="cabMobileSearch-card">
              {/* Pickup */}
              <div className="cabMobileSearch-locationRow">
                <div className="cabMobileSearch-icon">
                  <FaCircle size={10} />
                </div>

                <div className="cabMobileSearch-text">
                  <label className="cabMobileSearch-label">Pickup Location</label>
                  <div className="cabMobileSearch-input" onClick={handleFromCityClick}>
                    {departureCities[activeTab]?.name || "Enter Pickup Location"}
                  </div>
                </div>
              </div>

              {/* Swap */}
              <div className="cabMobileSearch-divider">
                <div className="cabMobileSearch-swapIcon">
                  <IoSwapVertical size={20} />
                </div>
              </div>

              {/* Drop */}
              <div className="cabMobileSearch-locationRow">
                <div className="cabMobileSearch-icon">
                  <FaMapMarkerAlt size={14} />
                </div>

                <div className="cabMobileSearch-text">
                  <label className="cabMobileSearch-label">Drop Location</label>
                  <div className="cabMobileSearch-input" onClick={handleToCityClick}>
                    {arrivalCities[activeTab]?.name || "Enter Drop Location"}
                  </div>
                </div>
              </div>
            </div>

            {/* Start Date */}
            <div className="cabMobileSearch-card">
              <div className="cabMobileSearch-locationRow">
                <div className="cabMobileSearch-icon">
                  <IoTimeOutline size={18} />
                </div>

                <div>
                  <label>Pick-up Date & Time</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDateTimePicker
                      value={dates.OUTSTATION.start}
                      onChange={(newValue) =>
                        updateDate("OUTSTATION", "start", newValue)
                      }
                      minDateTime={dayjs()}
                      views={["year", "month", "day", "hours", "minutes"]}
                      format="DD MMMM YYYY, hh:mm A"
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>

            {/* Return Date */}
            {showReturn && (
              <div className="cabMobileSearch-card">
                <div
                  className="cabMobileSearch-close"
                  onClick={() => setShowReturn(false)}
                >
                  <RxCross2 size={18} />
                </div>

                <div className="cabMobileSearch-locationRow">
                  <div className="cabMobileSearch-icon">
                    <IoTimeOutline size={18} />
                  </div>

                  <div>
                    <label>Return Date & Time</label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <MobileDateTimePicker
                        value={dates.OUTSTATION.end}
                        minDateTime={dates.OUTSTATION.start || dayjs()}
                        onChange={(newValue) =>
                          updateDate("OUTSTATION", "end", newValue)
                        }
                        views={["year", "month", "day", "hours", "minutes"]}
                        format="DD MMMM YYYY, hh:mm A"
                      />
                    </LocalizationProvider>
                  </div>
                </div>
              </div>
            )}

            {!showReturn && (
              <button
                type="button"
                className="cabMobileSearch-addReturn"
                onClick={() => setShowReturn(true)}
              >
                ADD RETURN
              </button>
            )}

            <button className="cabMobileSearch-searchBtn">SEARCH</button>
          </>
        )}

        {/* HOURLY TAB */}
        {activeTab === "HOURLY" && (
          <>
            {/* Pickup */}
            <div className="cabMobileSearch-card">
              <div className="cabMobileSearch-locationRow">
                <div className="cabMobileSearch-icon">
                  <FaCircle size={10} />
                </div>

                <div className="cabMobileSearch-text">
                  <label>Pickup Location</label>
                  <div className="cabMobileSearch-input" onClick={handleFromCityClick}>
                    {departureCities[activeTab]?.name || "Enter Pickup Location"}
                  </div>
                </div>
              </div>
            </div>

            {/* Date */}
            <div className="cabMobileSearch-card">
              <div className="cabMobileSearch-locationRow">
                <div className="cabMobileSearch-icon">
                  <IoTimeOutline size={18} />
                </div>

                <div>
                  <label>Pick-up Date & Time</label>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileDateTimePicker
                      value={dates.HOURLY.start}
                      minDateTime={dayjs()}
                      onChange={(newValue) =>
                        updateDate("HOURLY", "start", newValue)
                      }
                      views={["year", "month", "day", "hours", "minutes"]}
                      format="DD MMMM YYYY, hh:mm A"
                    />
                  </LocalizationProvider>
                </div>
              </div>
            </div>

            {/* Hour Selection */}
            <div className="cabMobileSearch-card" onClick={open}>
              <div className="cabMobileSearch-locationRow cabMobileSearch-rentRow">
                <div className="cabMobileSearch-icon">
                  <IoTimeOutline size={18} />
                </div>

                <div style={{ flex: 1 }}>
                  <label className="cabMobileSearch-label">Rent For</label>
                  <div className="cabMobileSearch-input">{rentHours}</div>
                </div>

                <div className="cabMobileSearch-chevron">
                  <IoMdArrowDropdown />
                </div>
              </div>
            </div>

            {showHoursModal && (
              <>
                <div className="cabMobileSearch-overlay" onClick={close} />
                <div
                  className="cabMobileSearch-hoursModal"
                  role="dialog"
                  aria-modal="true"
                  onClick={(e) => e.stopPropagation()}
                >
                  <div className="cabMobileSearch-hoursHandle" />

                  <div className="cabMobileSearch-hoursList">
                    {hours.map((hour) => (
                      <button
                        key={hour}
                        className={`cabMobileSearch-hourItem ${
                          hour === rentHours ? "active" : ""
                        }`}
                        onClick={() => onSelect(hour)}
                      >
                        {hour}
                      </button>
                    ))}
                  </div>
                </div>
              </>
            )}

            <button className="cabMobileSearch-searchBtn">SEARCH</button>
          </>
        )}
      </form>

      {/* CITY SELECTION MODALS */}
      {fromCitySelected && (
<CabCitySelection
  orname="Origin"
  code={departureCities[activeTab]?.code}
  name={departureCities[activeTab]?.name}
  setCity={(city) => 
    setDepartureCities(prev => ({ ...prev, [activeTab]: city }))
  }
  closeCitySelection={closeCitySelection}
/>
      )}

      {toCitySelected && (
<CabCitySelection
  orname="Destination"
  code={arrivalCities[activeTab]?.code}
  name={arrivalCities[activeTab]?.name}
  setCity={(city) => 
    setArrivalCities(prev => ({ ...prev, [activeTab]: city }))
  }
  closeCitySelection={closeCitySelection}
/>
      )}
    </div>
  );
};

export default CabMobileSearch;
